const ALPHA = "ABCDEFGHJKLMNPQRSTUVWXYZ"; // no I, O to avoid confusion

function fnv32(str) {
    let h = 0x811c9dc5;
    for (let i = 0; i < str.length; i++) {
        h ^= str.charCodeAt(i);
        h = (h * 0x01000193) >>> 0;
    }
    return h;
}

export function generateGridCode(email, ts = Date.now()) {
    const seed = `${email.toLowerCase().trim()}:${ts}`;
    const h = fnv32(seed);
    const a1 = ALPHA[(h >>> 24) % ALPHA.length];
    const a2 = ALPHA[((h >>> 16) & 0xff) % ALPHA.length];
    const num = 100 + ((h & 0xffff) % 900);
    return `${a1}${a2}-${num}`;
}

export function formatGridCode(code) {
    return `VK // ${code}`;
}